export default __webpack_public_path__ + "static/media/naidi-5-2.749065c1.svg";